import React from 'react';
import {RegistrationForm} from './RegistrationForm';
import {Provider} from 'react-redux';
import {store} from '../../store/rootReducer';

const ExternalUserRegistration: React.FC = () => {
  return (
    <Provider store={store}>
      <RegistrationForm />
    </Provider>
  );
};

export default ExternalUserRegistration;
